export enum THEME_MODE {
  LIGHT = 'light',
  DARK = 'dark',
}
export interface ThemeState {
  themeMode: THEME_MODE;
}
